import { withInstall } from '@lit-element/utils'
import Upload from './src/upload.vue'
import type { SFCWithInstall } from '@lit-element/utils'

export const LtUpload: SFCWithInstall<typeof Upload> = withInstall(Upload)
export default LtUpload

export * from './src/upload'
export * from './src/upload-content'
export * from './src/upload-list'
export * from './src/upload-dragger'
export * from './src/constants'
